/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Ptz_View_Only_HintInputs */

const vi_grower_area_camera_ptz_view_only_hint = /** @type {(inputs: Grower_Area_Camera_Ptz_View_Only_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera này chưa có token điều khiển. Thêm ở nút Sửa nếu đơn vị vận hành đã bàn giao API PTZ.`)
};

/**

* @param {Grower_Area_Camera_Ptz_View_Only_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_ptz_view_only_hint = /** @type {((inputs?: Grower_Area_Camera_Ptz_View_Only_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Ptz_View_Only_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_ptz_view_only_hint(inputs)
});